import { render } from "./user-edit.vue?vue&type=template&id=1b94ff2e"
import script from "./user-edit.vue?vue&type=script&lang=js"
export * from "./user-edit.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__